import { render, staticRenderFns } from "./beneficiary-form.vue?vue&type=template&id=52a27056&scoped=true&"
import script from "./beneficiary-form.vue?vue&type=script&lang=js&"
export * from "./beneficiary-form.vue?vue&type=script&lang=js&"
import style0 from "./beneficiary-form.vue?vue&type=style&index=0&id=52a27056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a27056",
  null
  
)

export default component.exports